import { render, staticRenderFns } from "./audit-description.component.vue?vue&type=template&id=edd185cc&scoped=true"
import script from "./audit-description.component.vue?vue&type=script&lang=ts"
export * from "./audit-description.component.vue?vue&type=script&lang=ts"
import style0 from "./audit-description.component.vue?vue&type=style&index=0&id=edd185cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd185cc",
  null
  
)

export default component.exports